<template>
<div class="comments-block">
  <div class="comments padded" :class="{'comments-empty' : !comments.length}">

      <div class="comment" v-for="comment in comments">
        <span class="avatar" style="background-image: url(images/michael.jpg);"></span>
        <div class="comment-content">
          <div class="comment-header">
            <strong>{{ comment.member.username }}</strong>
            <button class="textonly remove-link" @click="removeComment(comment.id)">delete</button>
            <br /><small class="muted">{{ comment.Date}}</small> 
          </div>
          <div class="comment-body">
            {{ comment.Message}}
          </div>
          <!--
          <div class="comment-footer muted">
            Item: <a href="#">Hide complexity features</a>
          </div>
          -->
        </div>
      </div>

      <loader v-if="loading"/>
      <div v-else-if="!comments.length" class="empty-state">
        <span class="material-icons ico">chat</span>
        <p>Messages</p>
        <button class="textonly" @click="setFocus()">Be the first to leave a comment</button>
      </div>
  </div>
  <div class="padded-xs comment-input">
    <form @submit.prevent="addComment">
      <input type="text" id="comment-field" class="input--control" v-model="yourComment" ref="addComment" />
      <button class="button" type="submit" v-if="showAddButton">Add</button>
    </form>
  </div>
</div>
</template>

<script>
  import InputDefault from '../form/InputDefault.vue'
  import Loader from '../ui/Loader.vue'
  import axios from 'axios'

  export default {
    components: {
      InputDefault,
      Loader
    },
    data: function(){
      return{
        yourComment: '',
        loading: true,
        comments: {},
        showAddButton: false,
        token: JSON.parse(localStorage.getItem('user')).id,
        memberId: JSON.parse(localStorage.getItem('user')).userId
      }
    },
    methods: {
      setFocus(){
         this.$refs.addComment.focus();
      },
      addComment(){
        const data = {
            Message: this.yourComment,
            ProjectBlockId: this.$route.params.projectblockid,
            memberId: this.memberId
        }
        axios.post(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/comments?access_token='+this.token, data)
          .then(
              response => {
                  this.getComments(),
                  this.loading = false
                  this.yourComment = ''
              },
              error => {
                  this.msgtext = error,
                  this.loading = false
              }
          )
      },
      removeComment(itemId){
          axios.delete(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/comments/'+itemId+'?access_token='+this.token)
          .then(
              response => this.getComments(),
              error => {
                  this.msgtext = error,
                  this.loading = false
              }
          )
      },
      getComments(){
          var filter = {
              where: {
                ProjectBlockId: this.$route.params.projectblockid
              },
              include: "member"
          };

          var filters = JSON.stringify(filter);

          axios.get(process.env.VUE_APP_ROOT_API+'/projects/'+this.$route.params.projectid+'/comments?filter='+filters+'&access_token='+this.token)
              .then(response => {
              this.comments = response.data
              this.loading = false
              this.scrollToEnd()
          })
      },
      scrollToEnd() {    	
        var container = document.querySelector(".comments");
        container.scrollTop = container.scrollHeight;
        console.log(container.scrollHeight)
      }
    },
    mounted(){
        this.getComments()
              this.scrollToEnd()
    },
        watch: {
            '$route' (to, from) {
                this.getComments()
            }
        }
  }
</script>


<style lang="scss">
  .comments-block{
    display: flex;
    flex-direction: column;
  }

  #comment-field{
    width: 100%;
  }

  .comments-empty{
    display: flex;
    padding: 0;

    .empty-state{
      margin: auto;

      button{
        outline: none !important;
      }
    }
  }

  .comments{
    flex: 1;
    overflow: auto;
    padding-bottom: 0;
  }

  .comment:hover {
      .remove-link{
          display: inline;

          &:hover{
              color: $error;
          }
      }
  }

  .comment{
    padding: 1.3rem 0;
    display: flex;

    .avatar{
      margin-right: 1.3rem;
      margin-top: .45rem;
    }

    .comment-content{
      flex: 1;
      line-height: 1.7rem;

      .comment-header{
        strong{
          margin-right: .4rem;
        }
      }
    }
    @media #{$phone} {
      .avatar{
        margin-right: 1rem;
        margin-top: .45rem;
        zoom: .75;
      }
    }
  }
</style>
